import styled from 'styled-components';
import { Header1Text } from '../Typography';

export const HeaderTitleWrapper = styled(Header1Text)`
  padding-left: ${(props) => props.theme.spacing.spacing5};
`;

export const HeaderPaddingWrapper = styled.div`
  padding: ${(props) => props.theme.spacing.spacing3} ${(props) => props.theme.spacing.spacing5};
`;
